import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import TablePhoneNo from "../../../../components/Tables/TablePhoneNo";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Menu,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import {
  Search as SearchIcon,
} from "@material-ui/icons";
import { maskedNumber, decryptPhoneNumber} from "../../../../helpers/utility";

import * as actions from "../../../../store/actions/actionIndex";
import CallerId from "../../../../components/Modal/CallerId";
import CallProgressBox from "../../../../components/Boxes/CallProgressBox";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  columnIcon: {
    backgroundColor: "#0a82da",
    color: "#ffffff",
    padding: "6px",
    fontSize: "32px !important",
    borderRadius: "5px",
    cursor: "pointer",
    margin: "10px",
  
  },
});

function CallHistory(props) {
      const classes = useStyles();
      const [page, setPage] =  useState(0);
      const [rowsPerPage, setRowsPerPage] = useState(10);
     const [BucketData, setBucketData]  =useState(props.calls)
     const allColumns = props.calls[0] ? Object.keys(props.calls[0]) : [];
    const [showModal, setShowModal] = useState(false)
    const [sendPhone, setSendPhone] = useState("")
    const [callerId, setCallerId] = useState("");
    const [leadId, setLeadId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
const [visibleColumns, setVisibleColumns] = useState(
  allColumns.slice(0, 6) 
);
  const [open, setOpen] = useState(
    props.agentState === "CALL_PROGRESS" ? true : false
  );
  const [selectedValue, setSelectedValue] = React.useState(
    props.agentState === "CALL_PROGRESS"
      ? { name: "", phone: props.custPhone ? props.custPhone : "" }
      : {}
  );
useEffect(() => {
  setPage(0);
}, [searchQuery]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // dial Call
  const dialHandler = (agentId, phone, leadId, name) => {
    if (props.agentState === "FREE") {
      if(props.campConf.third_party_caller_id === "1" && props.campConf.third_party_caller_id !== null)
        {
          setShowModal(true);
          setSendPhone(decryptPhoneNumber(phone))
          setLeadId(leadId)   
        }
        else{
      props.onAgentDial(agentId, phone, leadId);
      setOpen(true);
      setSelectedValue({ name: name, phone: phone });
        }
    } else {
      alert("Please disconnect the current call first.");
    }
  };
  const handleModalClose = () =>{
    setShowModal(false)
  }

  // Caller ID through
     const handleCaller = (selectId) =>{
  const callerIdToUse = selectId || "";
  setCallerId(callerIdToUse)
  props.onAgentDial(props.agentId, sendPhone, leadId, "", callerIdToUse);
   setShowModal(false)
  }

    const handleClose = React.useCallback(() => {
      setOpen(false);
      setSelectedValue({ name: "", phone: "" });
    }, [setOpen, setSelectedValue]);
  
    const filteredData = BucketData.filter((row) => {
  const lowerQuery = searchQuery.toLowerCase();
  return (
    (row.name && row.name.toLowerCase().includes(lowerQuery)) ||
    (row.cust_ph_no && row.cust_ph_no.toLowerCase().includes(lowerQuery))
  );
})
  return (
    <>
     {showModal && (
    <CallerId isOpen = {showModal} onClose={handleModalClose} onCallerIdSelect = {handleCaller} phoneNumber= {sendPhone} />
        )}
     <div className="abc" style={{display: "flex", justifyContent: "end", padding: "0 0 15px 0"}}>

                  <div className="searched">
                    <input
  className="searchText"
  id="standard-bare-name"
  variant="outlined"
  placeholder="Search by name or phone..."
  size="small"
  margin="normal"
  value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)}
/>
                     
                    <SearchIcon />
                  </div>
                </div>
              
   <Paper className={classes.root}>
   
     <TableContainer
            className={classes.leadTable}
            style={{ maxHeight: props.maxHeight, height: props.height }}
          >
            <Table stickyHeader aria-label="sticky table customized table">
              <TableHead>
                <TableRow>
            
                  {visibleColumns.map((column) => (
      <TableCell
        key={column}
        style={{
          whiteSpace: "nowrap",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {column.replace(/_/g, " ").replace(/(^\w{1})|(\s{1}\w{1})/g, (match) =>
          match.toUpperCase()
        )}
      </TableCell>
    ))}
                </TableRow>
              </TableHead>
             
              <TableBody>
      {filteredData
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, key) => {
          return (
            <>
            
            <TableRow hover role="checkbox" tabIndex={-1} key={key}>
              
              {visibleColumns.map((column, index) => {
                const value = row[column];

                return (
                  <TableCell
                    key={index}
                    style={{
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      maxWidth: "300px",
                    }}
                  >
                    {value &&
                      value.trim() !== "" &&
                      (column === "cust_ph_no") ? (
                      props.facilityConf.enable_number_mask ? (
                        props.facilityConf.enable_number_mask === "1" ? (
                          <>

                          <TablePhoneNo
                            phone={maskedNumber(
                              value,
                              props.facilityConf.mask_start_pos,
                              props.facilityConf.mask_end_pos
                            )}
                            dialHandler={() =>
                              dialHandler(
                                props.agentId,
                                value,
                                row["lead_id"],
                                row["name"]
                              )
                            }
                          />
                           </>
                        ) : (
    
                          <TablePhoneNo
                            phone={decryptPhoneNumber(
                              value,
                            )}
                            dialHandler={() =>
                              dialHandler(
                                props.agentId,
                                value,
                                row["lead_id"],
                                row["name"]
                              )
                            }
                          />
                      
                        ) 
                      ) : (
                        decryptPhoneNumber(value)
                      )
                    ) : (
                      <span
                        style={{
                          whiteSpace: "pre-wrap",
                          overflowWrap: "break-word",
                          maxWidth: "50px",
                        }}
                      >
                        {value}
                      </span>
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
            
    
            </>
          );
        })}
    </TableBody>
    
            </Table>
          </TableContainer>
            <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={props.calls.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
                 <CallProgressBox
                        selectedValue={selectedValue}
                        open={open}
                        handleClose={handleClose}
                      />                     

   </Paper>
     </>
  )
}


const mapStateToProps = (state) => {
  return {
    error: state.agentDial.error,
    loading: state.agentDial.loading,
    leadError: state.customerDetails.error,
    leadLoading: state.customerDetails.loading,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    campaignId: state.agentData.campaignId,
    facilityConf: state.agentConfig.facilityConf,
    campConf : state.agentConfig.campConf,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDial: (agentId, phone, leadId, listId, callerId) =>
      dispatch(actions.agentDial(agentId, phone, leadId,listId, callerId)),
    onGetCustomerDetails: (agentId, campaignId, leadId, leadType) =>
      dispatch(
        actions.getCustomerDetails(agentId, campaignId, leadId, leadType)
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CallHistory);
